import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import { MenuItem } from '@mui/material';
import Swal from 'sweetalert2';
const ViewRmstockGropyBy = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(462));
    console.log(permission);

    axios
      .get(`/rm-stock/listing-groupby-all/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setHeaders(response.data.data.header);
          setValue(response.data.data.productions);
          setData(response.data.data.productions_raw);



        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns =
    [
      {
        header: 'Location',
        accessorFn: (row) => `${(row.location_name) ? row.location_name.title : ""} `,
      },

      {
        header: 'Product',

        accessorFn: (row) => {
          if (row.stock_type === 'auto') {
            return row.product_name || '';
          }else{
           return `${(row.product_detail) ? row.product_detail.name : ""} `
          }
        },
      },

      // {
      //   header: 'Product',
      //   accessorFn: (row) => `${(row.product_detail) ? row.product_detail.name : ""} `,
      // },

      // {
      //   accessorKey: 'product_type',
      //   header: 'Product Type',
      // },
        {
        header: 'Product Type',

        accessorFn: (row) => {
          if (row.stock_type !== 'auto') {
            return row.product_type || '';
          }else if (row.stock_type === 'auto') {
           return `${(row.type == 1) ? 'Grade A' : "Grade B"} `
          }
        },
      },
      {
        header: 'Net Weight',

        accessorFn: (row) => {
          if (row.feed_type === 'raw') {
            return row.palletesation_raw_material?.net_weight || '';
          }else if (row.stock_type === 'auto') {
              return row.total_weight || '';
          }

          return row.quantity_processed;
        },
      },
      {
        header: 'Palletisation barcode ',
        accessorFn: (row) => {
          if (row.feed_type === 'raw') {
            return row.barcode || '';
          }else if (row.stock_type === 'auto') {
              return row.barcode || '';
          }

          return '';
        },
      },
      {
        header: 'Raw Material Lot Number',
        accessorFn: (row) => {
          if (row.feed_type === 'raw') {
            return row.lot_number || '';
          }else if (row.stock_type === 'auto') {
              return row.lot_number || '';
          }
          return '';
        },
      },
      {
        accessorKey: 'shift_date',
        header: 'Shift Date',
      },
      {
        accessorKey: 'shift',
        header: 'Shift',
      },

      {
        header: 'Created By',
        accessorFn: (row) =>
          row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}`.trim() : '',
      },
      {
        header: 'Created At',
        accessorFn: (row) =>
          row.created_at
            ? row.created_at.replace('T', ' ').substring(0, 19)
            : '',
      }


    ];
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/rm-stock/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              axios
                .get(`/rm-stock/listing-groupby-all/${id}`, {
                  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                })
                .then((response) => {
                  if (response.data.code === 200) {
                    setValue(response.data.data.productions);
                    setData(response.data.data.productions_all);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }


  const rawData = headers?.raw_count || {};

  const total = Object.values(rawData).reduce((sum, val) => {
    return sum + Number(val || 0);
  }, 0);

  console.log(headers);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Stock Group By Date and Location</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/rm-stock">Raw Material Stock</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Raw Material Stock Group By Date and Location
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Raw Material Stock Group By Date and Location</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3" >Shift Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name : ""}
                        </td>
                      </tr>
                      {Object.entries(headers?.raw_count || {}).map(([key, value], index) => (
                        <tr key={`raw-${index}`}>
                          <th className="p-3">{key}</th>
                          <td className="p-3">{Number(value).toFixed(2)} (KG)</td>
                        </tr>
                      ))}
                      <tr>
                        <th className="p-3">Total</th>
                        <td className="p-3">{total.toFixed(2)} (KG)</td>
                      </tr>



                    </table>

                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card p-5">
                  <h4 className="card-title">Raw Material Stock Listing</h4>
                  <div className="card-body p-0 pt-3">
                    <div className="table-responsive">
                      <MaterialReactTable columns={columns} data={data}
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                        //renderColumnActionsMenuItems 
                        renderRowActionMenuItems={({ row }) => [
                          // <MenuItem key="edit" onClick={() => editItem(row.original.id)}>Edit</MenuItem>,
                          <MenuItem key="delete" onClick={() => deleteItem(row.original.feed_id)}> Delete </MenuItem>

                        ]}
                      />
                    </div>

                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
export default ViewRmstockGropyBy;
